import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// material component
import Alert from "@mui/material/Alert";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
// jarr
import StateTextInput from "./common/StateTextInput";
import ClusterSettings from "./common/ClusterSettings";
import { closePanel, editLoadedObj } from "./slice";
import doEditObj from "../../hooks/doEditObj";
import doDownloadOPML from "../../hooks/doDownloadOPML";
import doUploadOPML from "../../hooks/doUploadOPML";
import useStyles from "./editPanelStyle";

const mapDispatchToProps = (dispatch) => ({
  commit(e) {
    e.preventDefault();
    dispatch(doEditObj("user"));
    dispatch(closePanel());
  },
  editPassword(password, passwordConf) {
    if (password === passwordConf) {
      dispatch(editLoadedObj({ key: "password", value: password}));
    }
  },
  uploadOPML(file, onResult) {
    dispatch(doUploadOPML(file, onResult));
  },
  downloadOPML() {
    dispatch(doDownloadOPML());
  },
});

function SettingsPanel({ editPassword, commit, uploadOPML, downloadOPML }) {
  const [pwdVal, setPwd] = useState("");
  const [pwdConfirm, setPwdConfirm] = useState("");
  const [showPasswd, setShowPasswd] = useState(false);
  const [opmlResult, setOpmlResult] = useState(null);
  const [opmlFileName, setOpmlFileName] = useState("");
  const fileInputRef = useRef(null);
  const classes = useStyles();
  return (
    <form onSubmit={(e) => commit(e)}>
    <FormControl component="fieldset">
      {["login", "email", "timezone"].map((key) => (
          <StateTextInput key={key} label={key} name={key}
            disabled={key === "login"} />
       ))}
      <ClusterSettings level="user" />
      <TextField label="Password" variant="outlined"
        className={classes.editPanelInput}
        value={pwdVal}
        error={pwdConfirm !== pwdVal}
        type={showPasswd ? "text" : "password"}
        onChange={(e) => {
          editPassword(e.target.value, pwdConfirm);
          setPwd(e.target.value);
        }} />
      <TextField label="Password confirmation" variant="outlined"
        className={classes.editPanelInput}
        value={pwdConfirm}
        error={pwdConfirm !== pwdVal}
        type={showPasswd ? "text" : "password"}
        onChange={(e) => {
          editPassword(pwdVal, e.target.value);
          setPwdConfirm(e.target.value);
        }} />
      <FormControlLabel control={<Switch
        checked={showPasswd}
        onChange={() => setShowPasswd(!showPasswd)}
        color="primary"
      />} label="Show password" />
      <Button variant="contained" color="primary" type="submit"
         className={classes.editPanelBtn}>
        Edit settings
      </Button>
      <Typography variant="subtitle1" style={{ marginTop: 20, marginBottom: 10 }}>
        Feed list backup
      </Typography>
      <Button variant="outlined" color="primary"
        className={classes.editPanelBtn}
        style={{ marginTop: 0 }}
        onClick={() => downloadOPML()}>
        Export feeds
      </Button>
      <input
        type="file"
        accept=".opml,.xml"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            setOpmlFileName(file.name);
            setOpmlResult(null);
            uploadOPML(file, setOpmlResult);
          }
          e.target.value = "";
        }}
      />
      <Button variant="outlined" color="primary"
        className={classes.editPanelBtn}
        onClick={() => fileInputRef.current.click()}>
        Import feeds
      </Button>
      {opmlFileName && !opmlResult && (
        <Typography variant="body2" style={{ marginTop: 8 }}>
          Uploading {opmlFileName}...
        </Typography>
      )}
      {opmlResult && opmlResult.error && (
        <Alert severity="error" style={{ marginTop: 8 }}>
          {opmlResult.error}
        </Alert>
      )}
      {opmlResult && !opmlResult.error && (
        <Alert severity="success" style={{ marginTop: 8 }}>
          {opmlResult.created} feed(s) created, {opmlResult.existing} already
          existed{opmlResult.failed ? `, ${opmlResult.failed} failed` : ""}.
        </Alert>
      )}
    </FormControl>
    </form>
  );
}

SettingsPanel.propTypes = {
  commit: PropTypes.func.isRequired,
  editPassword: PropTypes.func.isRequired,
  uploadOPML: PropTypes.func.isRequired,
  downloadOPML: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(SettingsPanel);
